import {
  createMultiStyleConfigHelpers,
  MultiStyleType,
  StyleThemingProps,
} from '~/utils/chakraUtils'
import { mergeMultiStyleConfig } from '~/utils/styleHelpers'

import { textStyleKeys } from '@mangovoice/design-system'
import { textStyles } from '@mangovoice/design-system'

import {
  hiddenRowActionStyle,
  revealedRowActionStyle,
  rowActionKeyboardRevealSelector,
  touchRowActionReveal,
} from './rowActionReveal'

export const QUICK_DIAL_ACTION_BUTTONS_CLASS_NAME = 'action-buttons'

const QuickDialListItemParts = [
  'container',
  'textContainer',
  'labelContainer',
  'labelText',
  'subLabelText',
  'buttonsContainer',
] as const

const helpers = createMultiStyleConfigHelpers(QuickDialListItemParts)
export const QuickDialListItemStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      flexShrink: 0,
      justifyContent: 'flex-start',
      alignItems: 'center',
      height: '3.75rem',
      width: 'full',
      paddingX: '0.75rem',
      gap: '0.75rem',
      borderRadius: '0.5rem',
      position: 'relative',
      _hover: {
        backgroundColor: 'bg.muted',
      },
      '&:has(:focus-visible)': {
        backgroundColor: 'bg.muted',
      },
      [rowActionKeyboardRevealSelector(QUICK_DIAL_ACTION_BUTTONS_CLASS_NAME)]:
        revealedRowActionStyle,
      ...touchRowActionReveal(QUICK_DIAL_ACTION_BUTTONS_CLASS_NAME),
    },
    textContainer: {
      flexDirection: 'column',
      justifyContent: 'center',
      gap: '0.25rem',
    },
    labelContainer: {
      alignItems: 'center',
      gap: '0.5rem',
    },
    labelText: {
      ...textStyles[textStyleKeys.Body1],
      color: 'fg.default',
    },
    subLabelText: {
      ...textStyles[textStyleKeys.Body3],
      color: 'fg.muted',
    },
    buttonsContainer: {
      display: 'flex',
      gap: '0.25rem',
      ...hiddenRowActionStyle,
    },
  },
})

export const useQuickDialListItemStyle = (props?: StyleThemingProps) => {
  return mergeMultiStyleConfig(QuickDialListItemStyle, props) as MultiStyleType<
    typeof QuickDialListItemParts
  >
}
